import { CommonModule } from "@angular/common";
import { Component, OnInit, computed, Input, Output, inject } from "@angular/core";
import { UserProfile } from "@models/user-profile";
import { LoggedInUserService } from "src/app/services/auth/logged-in-user-service";

@Component({
    selector: 'cvx-profile-icon',
    imports: [CommonModule],
    templateUrl: './cvx-profile.component.html',
    styleUrl: './cvx-profile.component.scss'
})
export class CvxProfileComponent implements OnInit {
  user!: UserProfile;
  initials: string = '';

  private loggedInUserService: LoggedInUserService = inject(LoggedInUserService);

  ngOnInit(): void {
    this.loggedInUserService.currentUser$.subscribe(data => {      
      if (data) {
        this.user = data;
        this.initials = this.getInitials();
      }
    });
      
  }

  protected srcImageUser = computed(() => {
    return '/images/no-avatar.png';
  }
  );

  protected getInitials = () => {
    const namePart = this.user.name.split('[')[0].trim(); // Remove the company part
    const [surname, firstname] = namePart.split(',').map(part => part.trim());
    return `${firstname.charAt(0)}${surname.charAt(0)}`;
  }

  protected getProfileImage = () => { 
      
  }
}